
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class CardFooterData extends Vue {
  @Prop() value!: any;
  @Prop() col12!: boolean;
}
